<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-add-tab-info">

    <vx-card title="Dados do botão">

      <!-- <div class="tabs-container px-6 pt-6"> -->

      <!-- <vs-tabs class="tab-action-btn-fill-conatiner"> -->
      <!-- <vs-tab :label="'Dados do botão'" icon-pack="feather" icon="icon-settings"> -->
      <!-- <div class="tab-text"> -->
      <div class="vx-row">

        <div class="vx-col md:w-1/6">
          <vs-input class="w-full" v-model="name" name="name" :label="$t('MODULE_ACTIONS.buttonLabel')" />
        </div>

        <div class="vx-col md:w-1/6">
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.icon') }}</label>
          <v-select :clearable="false" :options="$ICONS_LIST" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="icon">
            <template v-slot:option="option">
              <feather-icon :icon="option.label" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer" /> {{
            option.label }}
            </template>

          </v-select>
        </div>

        <div class="vx-col md:w-1/3">
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.url') }}</label>
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span>
                  <>
                </span>
              </div>
            </template>

            <vs-input v-model="url" placeholder="URL para disparo" />
          </vx-input-group>
        </div>

        <div class="vx-col">
          <!-- <vs-input class="w-full" v-model="index" name="index" :label="'Índice'" /> -->
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.index') }}</label>
          <vs-input-number v-model="index" min="1" />
        </div>

      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/6">
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.buttonDisplay') }}</label>
          <v-select :clearable="false" :options="buttonTypeOptions" v-model="buttonType" />
        </div>
        <div class="vx-col md:w-1/6">
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.httpMethod') }}</label>
          <v-select :clearable="false" :options="httpMethodOptions" v-model="httpMethod" />
        </div>
        <div class="vx-col md:w-1/6">
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.waitForResponse') }}</label>
          <v-select :clearable="false" :options="waitResponseOptions" v-model="waitResponse" />
        </div>
        <div class="vx-col md:w-1/6" v-if="waitResponse.value === true">
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.responseType') }}</label>
          <v-select :clearable="false" :options="responseTypeOptions" v-model="responseType" />
        </div>
        <div class="vx-col md:w-1/6" v-if="responseType.value === 'file_download' && waitResponse.value === true">
          <label class="vs-input--label">{{ $t('MODULE_ACTIONS.responseContentType') }}</label>
          <v-select :clearable="false" :options="contentTypeOptions" v-model="contentType" />
        </div>
        <div class="vx-col md:w-1/6"
          v-if="waitResponse.value === true && responseType.value === 'file_download' && contentType.value === 'application/octet-stream'">
          <!-- <label class="vs-input--label">Extensão</label> -->
          <!-- <v-select :clearable="false" :options="contentTypeOptions" v-model="contentType" /> -->
          <vs-input class="w-full" v-model="extension" name="extension" :label="$t('MODULE_ACTIONS.fileExtension')" />
        </div>
      </div>

      <div class="vx-row mt-4">

        <div class="vx-col md:w-1/2">
          <label class="vs-input--label">Roles com acesso (deixe vazio para exibir para todas)</label>
          <v-select
            multiple
            :options="roleOptions"
            label="name"
            :reduce="r => r.hash"
            v-model="selectedRoles"
            placeholder="Selecione as roles..."
          />
        </div>

      </div>

      <div class="vx-row mt-4">

        <div class="vx-col w-full">
          <vs-input class="w-full" v-model="description" name="description" :label="$t('MODULE_ACTIONS.description')" />
        </div>


      </div>
      <!-- </div> -->
      <!-- </vs-tab> -->
      <!-- </vs-tabs> -->

      <!-- </div> -->

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="saveChanges">{{
            $t('USER.EDIT.save_changes') }}</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning"
              @click="$router.push(`/module-actions/${$route.params.moduleHash}`)">{{
            $t('USER.EDIT.cancel') }}</vs-button>
          </div>
        </div>
      </div>

    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { performFetch, isValidHttpsUrl } from '../../helpers'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    action: String
  },
  data() {
    return {
      name: "",
      icon: "",
      url: "",
      description: "",
      index: 1,
      filename: '',
      httpMethodOptions: [
        'GET',
        'POST'
      ],
      httpMethod: 'GET',
      waitResponseOptions: [
        {
          label: 'Sim',
          value: true
        },
        {
          label: 'Não',
          value: false
        },
      ],
      waitResponse: {
        label: 'Sim',
        value: true
      },
      responseTypeOptions: [
        {
          label: 'Notificação',
          value: 'notification'
        },
        {
          label: 'Download de arquivo',
          value: 'file_download'
        }
      ],
      responseType: {
        label: 'Download de arquivo',
        value: 'file_download'
      },
      buttonTypeOptions: [
        {
          label: 'Lista',
          value: 'list'
        },
        {
          label: 'Registro',
          value: 'row'
        },
      ],
      buttonType: {
        label: 'Lista',
        value: 'list'
      },
      contentTypeOptions: [
        {
          label: 'CSV',
          value: 'text/csv'
        },
        {
          label: 'PDF',
          value: 'application/pdf'
        },
        {
          label: 'JSON',
          value: 'application/json'
        },
        {
          label: 'XML',
          value: 'application/xml'
        },
        {
          label: 'XLSX',
          value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        {
          label: 'HTML',
          value: 'text/html'
        },
        {
          label: 'ZIP',
          value: 'application/zip'
        },
        {
          label: 'PNG',
          value: 'image/png'
        },
        {
          label: 'JPEG',
          value: 'image/jpeg'
        },
        {
          label: 'Text file',
          value: 'text/plain'
        },
        {
          label: 'Binary file',
          value: 'application/octet-stream'
        }
      ],
      contentType: {
        label: 'CSV',
        value: 'text/csv'
      },
      extension: '',
      selectedRoles: [],
      roleOptions: []
    }
  },
  watch: {
    data: {
      immediate: true, // para disparar o watch na primeira renderização
      handler(newData) {
        if (newData) {
          if (Object.keys(newData).length > 0) {
            this.name = newData.name || '';
            this.icon = newData.icon || '';
            this.url = newData.url || '';
            this.description = newData.description || '';
            this.index = newData.index || 1;
            this.buttonType = this.buttonTypeOptions.find(x => x.value === newData.button_type)
            this.httpMethod = newData.http_method
            this.waitResponse = this.waitResponseOptions.find(x => x.value === newData.wait_response)
            this.responseType = newData.response_type ? this.responseTypeOptions.find(x => x.value === newData.response_type) : { label: 'Download de arquivo', value: 'file_download' }
            this.contentType = newData.response_content_type ? this.contentTypeOptions.find(x => x.value === newData.response_content_type) : { label: 'CSV', value: 'text/csv' }
            this.selectedRoles = Array.isArray(newData.roles) ? newData.roles : []
          }
        }
      }
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  async created() {
    await performFetch(this.$store.state.auth.api_url, {
      command: 'get_application_roles',
      parameters: {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token
      }
    })
      .then(async (response) => {
        if (response.status === 200) {
          await response.json().then((data) => {
            const flatten = (roles) => {
              const result = []
              const traverse = (list) => {
                list.forEach(r => {
                  if (r && r.role_hash) result.push({ hash: r.role_hash, name: r.role_name })
                  if (r && r.role_children && r.role_children.length) traverse(r.role_children)
                })
              }
              traverse(roles)
              return result
            }
            this.roleOptions = flatten(data.roles || [])
          })
        }
      })
      .catch(() => {})
  },
  mounted() {

    // console.log(this.data)

    // setTimeout(() => {
    //   if (Object.keys(this.data).length > 0) {
    //     this.name = this.data.name
    //     this.icon = this.data.icon
    //     this.url = this.data.url
    //     this.description = this.data.description
    //     this.index = this.data.index
    //   }
    // }, 300)
  },
  methods: {

    resetForm() {
      this.name = ''
      this.icon = ''
      this.url = ''
    },

    async saveChanges() {

      if (this.action === 'add') {

        if (!this.validateFields()) return

        this.$vs.loading({
          type: 'default'
        })

        await performFetch(this.$store.state.auth.api_url, {
          command: "module_action__add",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            data: {
              name: this.name,
              icon: this.icon,
              url: this.url,
              index: this.index,
              description: this.description,
              module_hash: this.$route.params.moduleHash,
              button_type: this.buttonType.value,
              http_method: this.httpMethod,
              wait_response: this.waitResponse.value,
              response_type: this.waitResponse.value ? this.responseType.value : null,
              response_content_type: this.waitResponse.value && this.responseType.value === 'file_download' ? this.contentType.value : null,
              extension: this.extension,
              roles: this.selectedRoles
            }
          }
        })
          .then(async (response) => {
            if (response.status === 200) {
              // await response.json()
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação realizada',
                text: 'Operação realizada com sucesso',
                // text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })
              this.$router.push(`/module-actions/${this.$route.params.moduleHash}`)
            } else if (response.status === 500) {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Atenção',
                text: 'Ocorreu um erro ao salvar o registro',
                // text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'error'
              })
            }
          })
          .catch(error => console.error('error 2'))

      } else {

        if (!this.validateFields()) return

        this.$vs.loading({
          type: 'default'
        })

        await performFetch(this.$store.state.auth.api_url, {
          command: "module_action__update",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            action_hash: this.$route.params.actionHash,
            data: {
              name: this.name,
              icon: this.icon,
              url: this.url,
              index: this.index,
              description: this.description,
              module_hash: this.$route.params.moduleHash,
              button_type: this.buttonType.value,
              http_method: this.httpMethod,
              wait_response: this.waitResponse.value,
              response_type: this.waitResponse.value ? this.responseType.value : null,
              response_content_type: this.waitResponse.value && this.responseType.value === 'file_download' ? this.contentType.value : null,
              extension: this.extension,
              roles: this.selectedRoles
            }
          }
        })
          .then(async (response) => {
            if (response.status === 200) {
              // await response.json()
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação realizada',
                text: 'Operação realizada com sucesso',
                // text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })
              this.$router.push(`/module-actions/${this.$route.params.moduleHash}`)
            } else if (response.status === 500) {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Atenção',
                text: 'Ocorreu um erro ao salvar o registro',
                // text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'error'
              })
            }
          })
          .catch(error => console.error('error 2'))

      }
    },
    validateFields() {

      if (!isValidHttpsUrl(this.url)) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo URL deve ser uma URL válida e segura',
          // text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.name) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Label é obrigatório',
          // text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.icon) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Ícone é obrigatório',
          // text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }


      return true
    }
  }
}
</script>
<style scoped>
.v-select .vs__dropdown-menu {
  position: absolute !important;
  z-index: 1000 !important;
}

.vx-card {
  position: relative;
}
</style>
